export enum FormState {
    None = 1, // stan początkowy
    SaveRequested, // kliknięty zapisz, jeszcze bez requesta (sprawdzeanie walidacji itp)
    Saving, // zapisywanie danych
    Success, // zapis się udał
    ProcessError, // coś wewnętrznego zablokowało zapis
    ValidationError, // zapis się nie powiódł
    DataHasChangedError, // dane zostały zmienione w tle
    ExternalError, // serwer dał dupy
    DataNotFound// dane wczytane do edycji nie zostały znalezione
}
